module.exports = __webpack_public_path__ + "img/nationwide.59fc681c.svg";